import { IExtensaoArquivo } from "../../../application/models";

export const opcoesExtensoes: IExtensaoArquivo[] = [
  {
    label: 'EXCEL - (.xlsx)',
    value: 'xlsx'
  },
  {
    label: 'CSV - (.csv)',
    value: 'csv'
  },
  {
    label: 'TEXTO - (.txt)',
    value: 'txt'
  }
]